import axios from 'axios'
import { BUSCAR_ENCOMENDAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarEncomendas (idEmpresa, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/encomendas/empresa/${idEmpresa}${urlFiltros}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_ENCOMENDAS,
      payload: {
        encomendas: response.data
      }
    })
  )
}
